import React from 'react';
import { Submenu } from '../Submenu';
import { ListMethodsPayments } from 'src/features/core/auth/components/ListMethodsPayments';

interface FooterNewProps {
  onLinkClick: (href: string) => void;
}

export const FooterNew: React.FC<FooterNewProps> = ({
  onLinkClick,
}): JSX.Element => (
  <div className="w-full bg-[#F14A3E] flex flex-col items-center justify-center p-5 mt-24">
    <div className="w-full flex flex-wrap md:justify-center justify-between gap-6 md:gap-40">
      <div>
        <h3 className="font-bold text-white text-lg mb-1">Contato</h3>
        <Submenu
          links={[
            {
              text: 'Fale Conosco',
              href: 'https://api.whatsapp.com/send/?phone=5527999311873&text&type=phone_number&app_absent=0',
            },
            { text: 'Elogios', href: '/elogio' },
            { text: 'Sugestões', href: '/suggestion' },
            { text: 'Reclamações', href: '/reclamation' },
          ]}
          onLinkClick={onLinkClick}
          className="flex flex-col h-auto gap-2"
          liClassName="scale-zoom-1 text-[#E5E7EB] hover:text-black "
        />
      </div>

      <div>
        <h3 className="font-bold text-white text-lg mb-1">Segurança</h3>
        <Submenu
          links={[
            {
              text: 'Políticas de Anúncio',
              href: '/advertising',
            },
            {
              text: 'LGPD',
              href: 'https://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm',
            },
            {
              text: 'Política de Privacidade',
              href: '/privacy-policy',
            },
          ]}
          onLinkClick={onLinkClick}
          className="flex flex-col h-auto gap-2"
          liClassName="scale-zoom-1 text-[#E5E7EB] hover:text-black "
        />
      </div>

      <div>
        <h3 className="font-bold text-[#E5E7EB] text-lg mb-1">Redes Sociais</h3>

        <Submenu
          links={[
            {
              text: 'Instagram',
              href: 'https://www.instagram.com/buunpo/',
            },
            { text: 'Facebook', href: '/' },
            {
              text: 'YouTube',
              href: 'https://www.youtube.com/@buunpo?si=-qKz3qrD6hJlLzf5',
            },
          ]}
          onLinkClick={onLinkClick}
          className="flex flex-col h-auto gap-2"
          liClassName="scale-zoom-1 text-[#E5E7EB] hover:text-black "
        />
      </div>

      <div>
        <h3 className="font-bold text-white text-lg mb-1">Acessos</h3>

        <Submenu
          links={[
            {
              text: 'Tutorial',
              href: '/tutorial',
            },
            {
              text: 'Loja Oficial Buunpo',
              href: '/store/1e3b4ddd-77b5-4fe3-b8e2-b1966e32031f',
            },
          ]}
          onLinkClick={onLinkClick}
          className="flex flex-col  h-auto gap-2 "
          liClassName="scale-zoom-1 text-[#E5E7EB] hover:text-black "
        />
      </div>

      <div className="w-full md:max-w-[250px]">
        <h3 className="font-bold text-white text-lg">Pagamentos</h3>
        <ListMethodsPayments />
      </div>
    </div>
    <div className="w-[95%] md:w-[90%] border-t border-gray-400 mt-5 mb-5" />

    <div className="flex flex-col text-center text-[#E5E7EB]">
      <h3>
        BUUP - Todos os Direitos Reservados BUUNPO | CNPJ 22.772.854/0001-29
      </h3>
      <h3>São Gabriel da Palha - ES | CEP: 29780-000</h3>
    </div>
  </div>
);
